import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { PatientAbsenceApiService } from "@featuresAY/patient-web-ay/services/api/patient-absence-api.service";
import {
	CreatePatientAbsence,
	CreatePatientAbsenceError,
	CreatePatientAbsenceSuccess,
	DeletePatientAbsence,
	DeletePatientAbsenceError,
	DeletePatientAbsenceSuccess,
	LoadPatientAbsence,
	LoadPatientAbsenceError,
	LoadPatientAbsenceSuccess,
	PatientAbsenceActionTypes,
	UpdatePatientAbsence,
	UpdatePatientAbsenceError,
	UpdatePatientAbsenceSuccess,
} from "@featuresAY/patient-web-ay/store/patient-absence/patient-absence.action";
import { catchError, map, mergeMap } from "rxjs/operators";
import { of } from "rxjs";

@Injectable()
export class PatientAbsenceEffects {
	constructor(
		private actions$: Actions,
		private patientAbsenceApiService: PatientAbsenceApiService,
	) {}

	loadPatientAbsence$ = createEffect(() =>
		this.actions$.pipe(
			ofType<LoadPatientAbsence>(PatientAbsenceActionTypes.LoadPatientAbsence),
			mergeMap((action) =>
				this.patientAbsenceApiService.getPatientAbsencesByPatientId(action.payload).pipe(
					map((patientAbsence) => new LoadPatientAbsenceSuccess(patientAbsence)),
					catchError((error) => of(new LoadPatientAbsenceError(error))),
				),
			),
		),
	);

	createPatientAbsence$ = createEffect(() =>
		this.actions$.pipe(
			ofType<CreatePatientAbsence>(PatientAbsenceActionTypes.CreatePatientAbsence),
			mergeMap((action) =>
				this.patientAbsenceApiService.createPatientAbsence(action.payload).pipe(
					map((patientAbsence) => new CreatePatientAbsenceSuccess(patientAbsence)),
					catchError((error) => of(new CreatePatientAbsenceError(error))),
				),
			),
		),
	);

	updatePatientAbsence$ = createEffect(() =>
		this.actions$.pipe(
			ofType<UpdatePatientAbsence>(PatientAbsenceActionTypes.UpdatePatientAbsence),
			mergeMap((action) =>
				this.patientAbsenceApiService.updatePatientAbsence(action.payload).pipe(
					map((patientAbsence) => new UpdatePatientAbsenceSuccess(patientAbsence)),
					catchError((error) => of(new UpdatePatientAbsenceError(error))),
				),
			),
		),
	);

	deletePatientAbsence$ = createEffect(() =>
		this.actions$.pipe(
			ofType<DeletePatientAbsence>(PatientAbsenceActionTypes.DeletePatientAbsence),
			mergeMap((action) =>
				this.patientAbsenceApiService.deletePatientAbsence(action.payload).pipe(
					map(() => new DeletePatientAbsenceSuccess()),
					catchError((error) => of(new DeletePatientAbsenceError(error))),
				),
			),
		),
	);
}
